// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfluencerClub_entry-component__7\\+1BY{
    margin-top: -5vw;
    height:50vw;
    overflow: hidden;
}

.InfluencerClub_entry-img__0O2e5{
    position: absolute;
    height: 50vw;
    width:100vw;
    object-fit: cover;
}

.InfluencerClub_entry-level__ldUMZ{
    position: absolute;
    z-index: 1;
    font-size: 5vw;
    /* font-size: 72px; */
    width: 40vw;
    margin-left:7vw;
    margin-top: 10vw;
}

.InfluencerClub_influencer-heading__kcWrp{
    margin-bottom: 0;
    font-family: dm-sans-medium;
}

.InfluencerClub_influencer-desc__qQJHF{
    font-size: 1.3vw;
    /* font-size: 18px; */
    margin-bottom: 0;
    font-family: dm-sans-medium;
}

.InfluencerClub_influencer-host-trip__Xi29T{
    width: 13.33vw;
    height: 3.6vw;
    background-color: #e65439;
    border-radius: 100vw;
    border: none;
    font-size: 1.5vw;
    color: white;
    cursor: pointer;
    font-family: dm-sans-medium;
}

.InfluencerClub_feature-trip-heading__5pjGG{
    font-size: 3.1vw;
    /* font-size: 44px; */
    text-align: center;
    margin-top: 7vw;
    margin-bottom: 0;
    font-family: dm-sans-regular;
}

.InfluencerClub_underline__rht4f{
    color: rgb(230, 84, 57);
    font-size: 3vw;
    text-align: center;
    margin-top: -2.5vw;
    margin-bottom: 0px;
    font-family: sans-serif;
}

.InfluencerClub_feature-trip__H6uIC{
    display: flex;
    flex-direction: column;
    margin-bottom: 7vw;
}

.InfluencerClub_feature-1__n4yn1{
    display: flex;
    flex-direction: row;
    width:83vw;
    margin:auto;
    margin-top:5vw;
}

.InfluencerClub_feature-1-img__txsj3{
    width:31vw;
    height: 25vw;
    object-fit: contain;
    border: 1px solid black;
    border-radius: 2vw;
    margin-right: 11vw;
}

.InfluencerClub_feature-1-text__HSOFg{
    display: flex;
    flex-direction: column;
    width:41.6vw;
    overflow: hidden;
    align-self: center;
}

.InfluencerClub_feature-1-item-1__5-ukk{
    font-size: 1vw;
    margin-bottom: 0;
    margin-top:0;
    font-family: dm-sans-regular;    
}

.InfluencerClub_feature-1-item-2__s8dOi{
    font-size: 2.2vw;
    /* font-size: 32px; */
    margin-top:0;
    margin-bottom: 0;
    font-family: dm-sans-regular;
}

.InfluencerClub_feature-1-item-3__3RVpH{
    font-size: 1vw;
    /* font-size: 14px; */
    margin-bottom:0;
    font-weight: 300;
    margin-top:1vw;
    font-family: dm-sans-regular;
}

.InfluencerClub_feature-button-host-trip__0ZSTJ{
    width: 22vw;
    height: 3.3vw;
    font-size: 1.2vw;
    border-radius: 2vw;
    border: none;
    background-color: #e65439;
    color: white;
    /* font-weight: bold; */
    margin-top: 2vw;
    cursor: pointer;
    font-family: dm-sans-regular;
}

.InfluencerClub_influencer-review-heading__iw-bh{
    font-size: 3.1vw;
    text-align: center;
    margin-bottom: 0;
    font-family: dm-sans-regular;
}

.InfluencerClub_influencer-review-container__fTNt-{
    display: flex;
    flex-direction: row;
    width: 83%;
    height: auto;
    margin: auto;
    margin-bottom: 5vw;
    margin-top: 5vw;
    justify-content: space-around;
}

.InfluencerClub_inf-rev-card__Ywygt{
    width:25vw;
    height: 25vw;
    border: 1px solid black;
    border-radius: 2vw;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.InfluencerClub_inf-rev-bgImg__kWYRY{
    position: absolute;
    border-radius: 2vw;
    width: 25vw;
    height: 25vw;
    object-fit: cover;
    z-index: -1;
    opacity: 0.5;
}

.InfluencerClub_semicolon-img__wrMA6{
    margin-left: 1vw;
    margin-top: 1vw;
    width: 3.1vw;
    height: 2.6vw;
}

.InfluencerClub_inf-dest-name__Dt7Ie{
    font-size: 1.2vw;
    margin-top:0;
    margin-bottom: 0;
    margin-left:1.4vw;
    font-family: dm-sans-regular;
}

.InfluencerClub_inf-month__tzRJn{
    margin-left: 1.4vw;
    margin-top: 0.2vw;
    margin-bottom: 0;
    font-size: 1.2vw;
    font-family: dm-sans-regular;
}

.InfluencerClub_inf-rev__BBwpK{
    margin-left: 1.4vw;
    margin-top: 0.8vw;
    color: #e65439;
    font-weight: 600;
    margin-bottom: 0;
    font-size: 1.2vw;
    font-family: dm-sans-regular;
}

.InfluencerClub_influencer-rev__jgRpB{
    margin-top: 0.6vw;
    max-height: 10vw;
    overflow-y: scroll;
    margin-left: 1.4vw;
    margin-right: 1.4vw;
    text-align: left;
    font-size: 1.2vw;
    margin-bottom: 0.5vw;
    font-family: dm-sans-regular;
}

.InfluencerClub_influencer-rev__jgRpB::-webkit-scrollbar{
    display: none;
}

.InfluencerClub_inf-name__VR0iv{
    font-size: 1.4vw;
    font-weight: 500;
    margin-left: 1.4vw;
    font-family: dm-sans-regular;
}

.InfluencerClub_inf-rev-img__Pwsbj{
    border-radius: 50%;
    border: 1px solid black;
    position: absolute;
    margin-left: 18vw;
    margin-top: 1vw;
    width: 6vw;
    height: 6vw;
}

.InfluencerClub_hide-scroll__zlPY7::-webkit-scrollbar{
    display: none;
}

.InfluencerClub_new-inf-card-container__0Bz4a{
    width: 85vw;
    margin-left: 7.5vw;
    height: 40vw;
    padding-top: 3vw;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.InfluencerClub_new-inf-card__jHCZB{
    width: 25vw;
    height: 30vw;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.InfluencerClub_new-inf-img__\\+liOz{
    width: 12vw;
    height: 12vw;
    object-fit: cover;
    border-radius: 50%;
    align-self: center;
    box-shadow: 0px 0px 20px grey;
    margin-top: 2vw;
}

.InfluencerClub_new-inf-review__ygyw5{
    height: 10vw;
    overflow: scroll;
    margin-top: 2vw;
    font-size: 1.2vw;
    font-family: dm-sans-light;
}


@media (max-width: 768px ){

    .InfluencerClub_entry-component__7\\+1BY{
        margin-top: -13vw;
        height: 79vw;
    }

    .InfluencerClub_entry-img__0O2e5{
        height: 79vw;
    }

    .InfluencerClub_entry-level__ldUMZ{
        z-index:0;
    }

    .InfluencerClub_influencer-heading__kcWrp{
        position: absolute;
        font-size: 6vw;
        margin-top: 10vw;
        margin-left: 0vw;
        width: 50vw;
    }

    .InfluencerClub_influencer-desc__qQJHF{
        position: absolute;
        font-size: 2.7vw;
        margin-top: 26vw;
        margin-left: 0vw;
        width: 60vw;
    }

    .InfluencerClub_influencer-host-trip__Xi29T{
        width: 25vw;
        position: absolute;
        margin-top: 33vw;
        height: 6vw;
        font-size: 2.8vw;
    }

    .InfluencerClub_feature-trip-heading__5pjGG{
        font-size: 4.5vw;
        /* text-align: center;
        margin-top: 7vw;
        margin-bottom: 0; */
    }

    .InfluencerClub_underline__rht4f{
        /* color: rgb(230, 84, 57); */
        font-size: 4vw;
        /* text-align: center;
        margin-top: -2.5vw;
        margin-bottom: 0px;*/
        font-family: serif; 
    }

    .InfluencerClub_feature-1__n4yn1{
        flex-direction: column;
        width: 50vw;
    }
    
    .InfluencerClub_feature-1-img__txsj3{
        margin: auto;
        width: 30vw;
        height: 30vw;
        object-fit: contain;
        border-radius: 3vw;
        margin-bottom: 2vw;
    }
    
    .InfluencerClub_feature-1-text__HSOFg{
        /* display: flex;
        flex-direction: column; */
        width:44vw;
        text-align: center;
        /* overflow: hidden;
        align-self: center; */
    }
    
    .InfluencerClub_feature-1-item-1__5-ukk{
        font-size: 3vw;
    }
    
    .InfluencerClub_feature-1-item-2__s8dOi{
        font-size: 4vw;
        margin-top:0;
        margin-bottom: 0;
    }
    
    .InfluencerClub_feature-1-item-3__3RVpH{
        font-size: 2vw;
        /* text-align: justify; */
        margin-bottom:0;
        font-weight: 300;
        margin-top:1vw;
    }

    .InfluencerClub_feature-button-host-trip__0ZSTJ{
        margin:auto;
        margin-top: 2vw;
        height: 4.4vw;
        font-size: 2vw;
        border-radius: 5vw;
    }


    .InfluencerClub_influencer-review-heading__iw-bh{
        font-size: 4.5vw;
    }

    /* .inf-extra-div{
        width: 95vw;
        overflow-x: hidden;
        margin-left:auto;
    } */
    
    .InfluencerClub_inf-rev-bgImg__kWYRY{
        position: absolute;
        border-radius: 2vw;
        width: 50vw;
        height: 50vw;
        object-fit: cover;
        z-index: -1;
    }
    
    .InfluencerClub_semicolon-img__wrMA6{
        margin-left: 1vw;
        margin-top: 1vw;
        width: 7vw;
        height: 5vw;
    }
    
    .InfluencerClub_inf-dest-name__Dt7Ie{
        font-size: 3vw;
        margin-top:1vw;
        margin-bottom: 0;
        margin-left:2vw;
    }
    
    .InfluencerClub_inf-month__tzRJn{
        margin-left: 2vw;
        margin-top: 0.5vw;
        margin-bottom: 0;
        font-size: 3vw;
    }
    
    .InfluencerClub_inf-rev__BBwpK{
        margin-left: 2vw;
        margin-top: 1vw;
        color: #e65439;
        font-weight: 600;
        margin-bottom: 0;
        font-size: 3vw;
    }
    
    .InfluencerClub_influencer-rev__jgRpB{
        margin-top: 1vw;
        min-height: 20vw;
        /* width:20vw; */
        word-wrap: break-word;
        /* transform: translateY(0%); */
        overflow-y: scroll;
        margin-left: 2vw;
        margin-right: 2vw;
        text-align: left;
        font-size: 3vw;
        margin-bottom: 0vw;
    }
    
    .InfluencerClub_influencer-rev__jgRpB::-webkit-scrollbar{
        display: none;
    }
    
    .InfluencerClub_inf-name__VR0iv{
        font-size: 3vw;
        font-weight: 500;
        margin-left: 2vw;
        margin-top: 1.5vw;
    }
    
    .InfluencerClub_inf-rev-img__Pwsbj{
        border-radius: 50%;
        border: 1px solid black;
        position: absolute;
        margin-left: 36vw;
        margin-top: 3vw;
        width: 10vw;
        height: 10vw;
    }

    .InfluencerClub_parent__kKeV2 {
        /* position: absolute; */
        display: flex;
        width: 90%; height: 52vw;
        /* left: 20%; top: 50%; */
        transform: translateY(0%);
        box-sizing: border-box;
        /* padding: 30px; */
        overflow-x: scroll;
        /* background: #f5f5f5; */
        white-space: nowrap;
      }

      .InfluencerClub_influencer-review-container__fTNt-{
        display: flex;
        width: 95%;

        box-sizing: border-box;
        height: 52vw;
        transform: translateY(0%);
        margin-left: 5%;
        overflow-x: scroll;
        /* white-space: nowrap; */
        
        justify-content: space-between;
    }
      
      .InfluencerClub_child__tcYZh {
        width: 50vw; height: 50vw;
        margin-right: 30px;
        padding: 25px;
        border: 1px solid black;
        box-sizing: border-box;
        /* background: #3b3b3b; */
        display:flex;
      }

    
    
    .InfluencerClub_inf-rev-card__Ywygt{
        min-width:50vw;
        height: 50vw;
        border: 1px solid black;
        border-radius: 2vw;
        display: flex;
        flex-direction: column;
        overflow: visible;
        margin-right: 5vw;
    }

    .InfluencerClub_new-inf-card-container__0Bz4a{
        width: 100vw;
        margin-left: 0;
        height: auto;
        padding-top: 3vw;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    
    .InfluencerClub_new-inf-card__jHCZB{
        width: 75vw;
        height: auto;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        margin-bottom: 5vw;
        text-align: justify;
    }
    
    .InfluencerClub_new-inf-img__\\+liOz{
        width: 30vw;
        height: 30vw;
        object-fit: cover;
        border-radius: 50%;
        align-self: center;
        box-shadow: 0px 0px 20px grey;
        margin-top: 5vw;
        margin-bottom: 3vw;
    }
    
    .InfluencerClub_new-inf-review__ygyw5{
        height: 30vw;
        overflow: scroll;
        margin-top: 2vw;
        font-size: 3.5vw;
        font-family: dm-sans-light;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/InfluencerClub/InfluencerClub.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;;AAGA;;IAEI;QACI,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,gBAAgB;QAChB,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB;;2BAEmB;IACvB;;IAEA;QACI,6BAA6B;QAC7B,cAAc;QACd;;4BAEoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI;iCACyB;QACzB,UAAU;QACV,kBAAkB;QAClB;6BACqB;IACzB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,eAAe;QACf,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,aAAa;QACb,cAAc;QACd,kBAAkB;IACtB;;;IAGA;QACI,gBAAgB;IACpB;;IAEA;;;;OAIG;;IAEH;QACI,kBAAkB;QAClB,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,UAAU;QACV,WAAW;IACf;;IAEA;QACI,cAAc;QACd,cAAc;QACd,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,qBAAqB;QACrB,+BAA+B;QAC/B,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,uBAAuB;QACvB,kBAAkB;QAClB,iBAAiB;QACjB,eAAe;QACf,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,wBAAwB;QACxB,aAAa;QACb,UAAU,EAAE,YAAY;QACxB,yBAAyB;QACzB,yBAAyB;QACzB,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;QAClB,yBAAyB;QACzB,mBAAmB;MACrB;;MAEA;QACE,aAAa;QACb,UAAU;;QAEV,sBAAsB;QACtB,YAAY;QACZ,yBAAyB;QACzB,eAAe;QACf,kBAAkB;QAClB,yBAAyB;;QAEzB,8BAA8B;IAClC;;MAEE;QACE,WAAW,EAAE,YAAY;QACzB,kBAAkB;QAClB,aAAa;QACb,uBAAuB;QACvB,sBAAsB;QACtB,yBAAyB;QACzB,YAAY;MACd;;;;IAIF;QACI,cAAc;QACd,YAAY;QACZ,uBAAuB;QACvB,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,cAAc;QACd,YAAY;QACZ,gBAAgB;QAChB,sBAAsB;QACtB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,kBAAkB;QAClB,6BAA6B;QAC7B,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf,gBAAgB;QAChB,0BAA0B;IAC9B;AACJ","sourcesContent":[".entry-component{\n    margin-top: -5vw;\n    height:50vw;\n    overflow: hidden;\n}\n\n.entry-img{\n    position: absolute;\n    height: 50vw;\n    width:100vw;\n    object-fit: cover;\n}\n\n.entry-level{\n    position: absolute;\n    z-index: 1;\n    font-size: 5vw;\n    /* font-size: 72px; */\n    width: 40vw;\n    margin-left:7vw;\n    margin-top: 10vw;\n}\n\n.influencer-heading{\n    margin-bottom: 0;\n    font-family: dm-sans-medium;\n}\n\n.influencer-desc{\n    font-size: 1.3vw;\n    /* font-size: 18px; */\n    margin-bottom: 0;\n    font-family: dm-sans-medium;\n}\n\n.influencer-host-trip{\n    width: 13.33vw;\n    height: 3.6vw;\n    background-color: #e65439;\n    border-radius: 100vw;\n    border: none;\n    font-size: 1.5vw;\n    color: white;\n    cursor: pointer;\n    font-family: dm-sans-medium;\n}\n\n.feature-trip-heading{\n    font-size: 3.1vw;\n    /* font-size: 44px; */\n    text-align: center;\n    margin-top: 7vw;\n    margin-bottom: 0;\n    font-family: dm-sans-regular;\n}\n\n.underline{\n    color: rgb(230, 84, 57);\n    font-size: 3vw;\n    text-align: center;\n    margin-top: -2.5vw;\n    margin-bottom: 0px;\n    font-family: sans-serif;\n}\n\n.feature-trip{\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 7vw;\n}\n\n.feature-1{\n    display: flex;\n    flex-direction: row;\n    width:83vw;\n    margin:auto;\n    margin-top:5vw;\n}\n\n.feature-1-img{\n    width:31vw;\n    height: 25vw;\n    object-fit: contain;\n    border: 1px solid black;\n    border-radius: 2vw;\n    margin-right: 11vw;\n}\n\n.feature-1-text{\n    display: flex;\n    flex-direction: column;\n    width:41.6vw;\n    overflow: hidden;\n    align-self: center;\n}\n\n.feature-1-item-1{\n    font-size: 1vw;\n    margin-bottom: 0;\n    margin-top:0;\n    font-family: dm-sans-regular;    \n}\n\n.feature-1-item-2{\n    font-size: 2.2vw;\n    /* font-size: 32px; */\n    margin-top:0;\n    margin-bottom: 0;\n    font-family: dm-sans-regular;\n}\n\n.feature-1-item-3{\n    font-size: 1vw;\n    /* font-size: 14px; */\n    margin-bottom:0;\n    font-weight: 300;\n    margin-top:1vw;\n    font-family: dm-sans-regular;\n}\n\n.feature-button-host-trip{\n    width: 22vw;\n    height: 3.3vw;\n    font-size: 1.2vw;\n    border-radius: 2vw;\n    border: none;\n    background-color: #e65439;\n    color: white;\n    /* font-weight: bold; */\n    margin-top: 2vw;\n    cursor: pointer;\n    font-family: dm-sans-regular;\n}\n\n.influencer-review-heading{\n    font-size: 3.1vw;\n    text-align: center;\n    margin-bottom: 0;\n    font-family: dm-sans-regular;\n}\n\n.influencer-review-container{\n    display: flex;\n    flex-direction: row;\n    width: 83%;\n    height: auto;\n    margin: auto;\n    margin-bottom: 5vw;\n    margin-top: 5vw;\n    justify-content: space-around;\n}\n\n.inf-rev-card{\n    width:25vw;\n    height: 25vw;\n    border: 1px solid black;\n    border-radius: 2vw;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.inf-rev-bgImg{\n    position: absolute;\n    border-radius: 2vw;\n    width: 25vw;\n    height: 25vw;\n    object-fit: cover;\n    z-index: -1;\n    opacity: 0.5;\n}\n\n.semicolon-img{\n    margin-left: 1vw;\n    margin-top: 1vw;\n    width: 3.1vw;\n    height: 2.6vw;\n}\n\n.inf-dest-name{\n    font-size: 1.2vw;\n    margin-top:0;\n    margin-bottom: 0;\n    margin-left:1.4vw;\n    font-family: dm-sans-regular;\n}\n\n.inf-month{\n    margin-left: 1.4vw;\n    margin-top: 0.2vw;\n    margin-bottom: 0;\n    font-size: 1.2vw;\n    font-family: dm-sans-regular;\n}\n\n.inf-rev{\n    margin-left: 1.4vw;\n    margin-top: 0.8vw;\n    color: #e65439;\n    font-weight: 600;\n    margin-bottom: 0;\n    font-size: 1.2vw;\n    font-family: dm-sans-regular;\n}\n\n.influencer-rev{\n    margin-top: 0.6vw;\n    max-height: 10vw;\n    overflow-y: scroll;\n    margin-left: 1.4vw;\n    margin-right: 1.4vw;\n    text-align: left;\n    font-size: 1.2vw;\n    margin-bottom: 0.5vw;\n    font-family: dm-sans-regular;\n}\n\n.influencer-rev::-webkit-scrollbar{\n    display: none;\n}\n\n.inf-name{\n    font-size: 1.4vw;\n    font-weight: 500;\n    margin-left: 1.4vw;\n    font-family: dm-sans-regular;\n}\n\n.inf-rev-img{\n    border-radius: 50%;\n    border: 1px solid black;\n    position: absolute;\n    margin-left: 18vw;\n    margin-top: 1vw;\n    width: 6vw;\n    height: 6vw;\n}\n\n.hide-scroll::-webkit-scrollbar{\n    display: none;\n}\n\n.new-inf-card-container{\n    width: 85vw;\n    margin-left: 7.5vw;\n    height: 40vw;\n    padding-top: 3vw;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.new-inf-card{\n    width: 25vw;\n    height: 30vw;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.new-inf-img{\n    width: 12vw;\n    height: 12vw;\n    object-fit: cover;\n    border-radius: 50%;\n    align-self: center;\n    box-shadow: 0px 0px 20px grey;\n    margin-top: 2vw;\n}\n\n.new-inf-review{\n    height: 10vw;\n    overflow: scroll;\n    margin-top: 2vw;\n    font-size: 1.2vw;\n    font-family: dm-sans-light;\n}\n\n\n@media (max-width: 768px ){\n\n    .entry-component{\n        margin-top: -13vw;\n        height: 79vw;\n    }\n\n    .entry-img{\n        height: 79vw;\n    }\n\n    .entry-level{\n        z-index:0;\n    }\n\n    .influencer-heading{\n        position: absolute;\n        font-size: 6vw;\n        margin-top: 10vw;\n        margin-left: 0vw;\n        width: 50vw;\n    }\n\n    .influencer-desc{\n        position: absolute;\n        font-size: 2.7vw;\n        margin-top: 26vw;\n        margin-left: 0vw;\n        width: 60vw;\n    }\n\n    .influencer-host-trip{\n        width: 25vw;\n        position: absolute;\n        margin-top: 33vw;\n        height: 6vw;\n        font-size: 2.8vw;\n    }\n\n    .feature-trip-heading{\n        font-size: 4.5vw;\n        /* text-align: center;\n        margin-top: 7vw;\n        margin-bottom: 0; */\n    }\n\n    .underline{\n        /* color: rgb(230, 84, 57); */\n        font-size: 4vw;\n        /* text-align: center;\n        margin-top: -2.5vw;\n        margin-bottom: 0px;*/\n        font-family: serif; \n    }\n\n    .feature-1{\n        flex-direction: column;\n        width: 50vw;\n    }\n    \n    .feature-1-img{\n        margin: auto;\n        width: 30vw;\n        height: 30vw;\n        object-fit: contain;\n        border-radius: 3vw;\n        margin-bottom: 2vw;\n    }\n    \n    .feature-1-text{\n        /* display: flex;\n        flex-direction: column; */\n        width:44vw;\n        text-align: center;\n        /* overflow: hidden;\n        align-self: center; */\n    }\n    \n    .feature-1-item-1{\n        font-size: 3vw;\n    }\n    \n    .feature-1-item-2{\n        font-size: 4vw;\n        margin-top:0;\n        margin-bottom: 0;\n    }\n    \n    .feature-1-item-3{\n        font-size: 2vw;\n        /* text-align: justify; */\n        margin-bottom:0;\n        font-weight: 300;\n        margin-top:1vw;\n    }\n\n    .feature-button-host-trip{\n        margin:auto;\n        margin-top: 2vw;\n        height: 4.4vw;\n        font-size: 2vw;\n        border-radius: 5vw;\n    }\n\n\n    .influencer-review-heading{\n        font-size: 4.5vw;\n    }\n\n    /* .inf-extra-div{\n        width: 95vw;\n        overflow-x: hidden;\n        margin-left:auto;\n    } */\n    \n    .inf-rev-bgImg{\n        position: absolute;\n        border-radius: 2vw;\n        width: 50vw;\n        height: 50vw;\n        object-fit: cover;\n        z-index: -1;\n    }\n    \n    .semicolon-img{\n        margin-left: 1vw;\n        margin-top: 1vw;\n        width: 7vw;\n        height: 5vw;\n    }\n    \n    .inf-dest-name{\n        font-size: 3vw;\n        margin-top:1vw;\n        margin-bottom: 0;\n        margin-left:2vw;\n    }\n    \n    .inf-month{\n        margin-left: 2vw;\n        margin-top: 0.5vw;\n        margin-bottom: 0;\n        font-size: 3vw;\n    }\n    \n    .inf-rev{\n        margin-left: 2vw;\n        margin-top: 1vw;\n        color: #e65439;\n        font-weight: 600;\n        margin-bottom: 0;\n        font-size: 3vw;\n    }\n    \n    .influencer-rev{\n        margin-top: 1vw;\n        min-height: 20vw;\n        /* width:20vw; */\n        word-wrap: break-word;\n        /* transform: translateY(0%); */\n        overflow-y: scroll;\n        margin-left: 2vw;\n        margin-right: 2vw;\n        text-align: left;\n        font-size: 3vw;\n        margin-bottom: 0vw;\n    }\n    \n    .influencer-rev::-webkit-scrollbar{\n        display: none;\n    }\n    \n    .inf-name{\n        font-size: 3vw;\n        font-weight: 500;\n        margin-left: 2vw;\n        margin-top: 1.5vw;\n    }\n    \n    .inf-rev-img{\n        border-radius: 50%;\n        border: 1px solid black;\n        position: absolute;\n        margin-left: 36vw;\n        margin-top: 3vw;\n        width: 10vw;\n        height: 10vw;\n    }\n\n    .parent {\n        /* position: absolute; */\n        display: flex;\n        width: 90%; height: 52vw;\n        /* left: 20%; top: 50%; */\n        transform: translateY(0%);\n        box-sizing: border-box;\n        /* padding: 30px; */\n        overflow-x: scroll;\n        /* background: #f5f5f5; */\n        white-space: nowrap;\n      }\n\n      .influencer-review-container{\n        display: flex;\n        width: 95%;\n\n        box-sizing: border-box;\n        height: 52vw;\n        transform: translateY(0%);\n        margin-left: 5%;\n        overflow-x: scroll;\n        /* white-space: nowrap; */\n        \n        justify-content: space-between;\n    }\n      \n      .child {\n        width: 50vw; height: 50vw;\n        margin-right: 30px;\n        padding: 25px;\n        border: 1px solid black;\n        box-sizing: border-box;\n        /* background: #3b3b3b; */\n        display:flex;\n      }\n\n    \n    \n    .inf-rev-card{\n        min-width:50vw;\n        height: 50vw;\n        border: 1px solid black;\n        border-radius: 2vw;\n        display: flex;\n        flex-direction: column;\n        overflow: visible;\n        margin-right: 5vw;\n    }\n\n    .new-inf-card-container{\n        width: 100vw;\n        margin-left: 0;\n        height: auto;\n        padding-top: 3vw;\n        box-sizing: border-box;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n    \n    .new-inf-card{\n        width: 75vw;\n        height: auto;\n        display: flex;\n        flex-direction: column;\n        overflow: hidden;\n        margin-bottom: 5vw;\n        text-align: justify;\n    }\n    \n    .new-inf-img{\n        width: 30vw;\n        height: 30vw;\n        object-fit: cover;\n        border-radius: 50%;\n        align-self: center;\n        box-shadow: 0px 0px 20px grey;\n        margin-top: 5vw;\n        margin-bottom: 3vw;\n    }\n    \n    .new-inf-review{\n        height: 30vw;\n        overflow: scroll;\n        margin-top: 2vw;\n        font-size: 3.5vw;\n        font-family: dm-sans-light;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"entry-component": `InfluencerClub_entry-component__7+1BY`,
	"entry-img": `InfluencerClub_entry-img__0O2e5`,
	"entry-level": `InfluencerClub_entry-level__ldUMZ`,
	"influencer-heading": `InfluencerClub_influencer-heading__kcWrp`,
	"influencer-desc": `InfluencerClub_influencer-desc__qQJHF`,
	"influencer-host-trip": `InfluencerClub_influencer-host-trip__Xi29T`,
	"feature-trip-heading": `InfluencerClub_feature-trip-heading__5pjGG`,
	"underline": `InfluencerClub_underline__rht4f`,
	"feature-trip": `InfluencerClub_feature-trip__H6uIC`,
	"feature-1": `InfluencerClub_feature-1__n4yn1`,
	"feature-1-img": `InfluencerClub_feature-1-img__txsj3`,
	"feature-1-text": `InfluencerClub_feature-1-text__HSOFg`,
	"feature-1-item-1": `InfluencerClub_feature-1-item-1__5-ukk`,
	"feature-1-item-2": `InfluencerClub_feature-1-item-2__s8dOi`,
	"feature-1-item-3": `InfluencerClub_feature-1-item-3__3RVpH`,
	"feature-button-host-trip": `InfluencerClub_feature-button-host-trip__0ZSTJ`,
	"influencer-review-heading": `InfluencerClub_influencer-review-heading__iw-bh`,
	"influencer-review-container": `InfluencerClub_influencer-review-container__fTNt-`,
	"inf-rev-card": `InfluencerClub_inf-rev-card__Ywygt`,
	"inf-rev-bgImg": `InfluencerClub_inf-rev-bgImg__kWYRY`,
	"semicolon-img": `InfluencerClub_semicolon-img__wrMA6`,
	"inf-dest-name": `InfluencerClub_inf-dest-name__Dt7Ie`,
	"inf-month": `InfluencerClub_inf-month__tzRJn`,
	"inf-rev": `InfluencerClub_inf-rev__BBwpK`,
	"influencer-rev": `InfluencerClub_influencer-rev__jgRpB`,
	"inf-name": `InfluencerClub_inf-name__VR0iv`,
	"inf-rev-img": `InfluencerClub_inf-rev-img__Pwsbj`,
	"hide-scroll": `InfluencerClub_hide-scroll__zlPY7`,
	"new-inf-card-container": `InfluencerClub_new-inf-card-container__0Bz4a`,
	"new-inf-card": `InfluencerClub_new-inf-card__jHCZB`,
	"new-inf-img": `InfluencerClub_new-inf-img__+liOz`,
	"new-inf-review": `InfluencerClub_new-inf-review__ygyw5`,
	"parent": `InfluencerClub_parent__kKeV2`,
	"child": `InfluencerClub_child__tcYZh`
};
export default ___CSS_LOADER_EXPORT___;
